var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 33,
    viewBox: "0 0 51 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_97",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 0.5H0.5V32.5H50.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9545 23.3571V14.2143H5.04545V23.3571H0.5V27.9286H2.77273C2.77273 29.141 3.25162 30.3038 4.10406 31.1611C4.9565 32.0184 6.11265 32.5 7.31818 32.5C8.52371 32.5 9.67987 32.0184 10.5323 31.1611C11.3847 30.3038 11.8636 29.141 11.8636 27.9286H39.1364C39.1364 29.141 39.6153 30.3038 40.4677 31.1611C41.3201 32.0184 42.4763 32.5 43.6818 32.5C44.8873 32.5 46.0435 32.0184 46.8959 31.1611C47.7484 30.3038 48.2273 29.141 48.2273 27.9286H50.5V23.3571H45.9545ZM34.5909 21.0714H16.4091V18.7857H34.5909V21.0714ZM45.9545 0.5H5.04545V11.9286H45.9545V0.5ZM34.5909 7.35714H16.4091V5.07143H34.5909V7.35714Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarType);
export default __webpack_public_path__ + "static/media/car-type.0284232d8173c6102a90ba33eed5afe4.svg";
export { ForwardRef as ReactComponent };